<div class="w-full" [formGroup]="formGroup">
  <!-- External Label (like in textbox component) -->
  <label *ngIf="label" class="block text-sm font-medium text-gray-700 mb-2">
    {{ label }}
    <span *ngIf="required" class="text-red-500 ml-1">*</span>
  </label>

  <!-- Material Form Field with Custom Styling -->
  <div class="relative" >
    <mat-form-field 
      [appearance]="'fill'" 
      [floatLabel]="'auto'"
      class="w-full custom-datepicker-field">
      
      <!-- Hidden Label (since we show it externally) -->
      <mat-label style="display: none;"></mat-label>

      <!-- Datepicker Input Field -->
      <input 
        matInput
        [matDatepicker]="picker"
        [placeholder]="placeholder"
        [disabled]="isDisabled"
        [min]="minDate"
        [max]="maxDate"
        [value]="value"
        [formControlName]="fControlName"
        (dateInput)="onDateInput($event)"
        (dateChange)="onDateChange($event)"
        (blur)="onBlur()"
        class="custom-input"
        autocomplete="off"
        [required]="required"
        readonly>

        <!-- <input 
        *ngIf="isFormControl && formControl"
        matInput
        [matDatepicker]="picker"
        [placeholder]="placeholder"
        [disabled]="isDisabled"
        [min]="minDate"
        [max]="maxDate"
        [value]="value"
        [formControl]="formControl"
        (dateInput)="onDateInput($event)"
        (dateChange)="onDateChange($event)"
        (blur)="onBlur()"
        class="custom-input"
        autocomplete="off"
        readonly>

        <input 
        *ngIf="!isFormControl"
        matInput
        [matDatepicker]="picker"
        [placeholder]="placeholder"
        [disabled]="isDisabled"
        [min]="minDate"
        [max]="maxDate"
        [value]="value"
        (dateInput)="onDateInput($event)"
        (dateChange)="onDateChange($event)"
        (blur)="onBlur()"
        class="custom-input"
        autocomplete="off"
        readonly> -->

      <!-- Calendar Icon (positioned absolutely like textbox suffix icon) -->
      <mat-icon 
        matSuffix 
        class="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 !text-lg !leading-none cursor-pointer"
        (click)="picker.open()">
        calendar_today
      </mat-icon>

    </mat-form-field>

    <!-- Datepicker -->
    <mat-datepicker #picker 
      [touchUi]="touchUi"
      [startView]="startView"
      [disabled]="isDisabled">
    </mat-datepicker>
  </div>

  <!-- Error Messages (styled like textbox component) -->
    <div *ngFor="let error of errorMessages" class="text-red-500 text-sm mt-1">
        {{ error }}
    </div>
  <!-- Helper Text -->
  <div *ngIf="helperText" class="text-xs text-gray-500 mt-1">
    {{ helperText }}
  </div>
</div>
